import { Link } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import api from '../api/api';
import Loader from '../shared/loader';
import arrayUtilities from '../../utilities/arrayUtilities';
import { Modal } from 'react-bootstrap';
import stringHelpers from '../../utilities/stringHelpers';
import { ErrorModal } from '../../utilities/errorModal';
import Enum from '../../utilities/enum';
import { ToggleWithLocalisedLoading } from '../shared/toggleWithLocalisedLoading';

export default function DebtCollectionProviders({ organisationId, token }) {
    const [debtCollectionProviders, setDebtCollectionProviders] = useState(null);
    const [isLoading, setIsLoading] = useState(false)
    const [deleteModal, setDeleteModal] = useState(null)
    const [errorMessage, setErrorMessage] = useState(null)
    const [preExistingDefault, setPreExistingDefault] = useState(null)
    const [toggleDefaultId, setToggleDefaultId] = useState(null)

    const getDebtCollectionProviders = () => {
        setIsLoading(true)
        api.getDebtCollectionProviders(
            (data) => {
                setDebtCollectionProviders(data)
                setIsLoading(false)
            },
            (error) => {
                console.log(error)
                setIsLoading(false)
            },
            organisationId,
            token
        )
    };

    useEffect(() => {
        getDebtCollectionProviders()
    }, []);

    useEffect(() => {
        if (arrayUtilities.isNullOrEmpty(debtCollectionProviders)) {
            setPreExistingDefault(null)
            return
        }
        const existingDefault = debtCollectionProviders.find(provider => provider.isDefault)
        setPreExistingDefault(existingDefault ?? null)
    }, [debtCollectionProviders]);

    const handleDelete = () => {
        api.deleteDebtCollectionProvider(
            data => {
                if (data.isError) {
                    setErrorMessage(data.errorMessage)
                } else {
                    getDebtCollectionProviders()
                }
            },
            error => {
                console.log(error)
                setErrorMessage(error.message)
            },
            deleteModal.id,
            organisationId, token
        )
    }

    const toggleDebtProviderDefaultStatus = (providerId, isDefault, setErrorMessage) => {
        const key = "isDefault"
        api.toggleDebtCollectionDefault(
            data => {
                if (data.isError) {
                    setErrorMessage(data.errorMessage)
                    arrayUtilities.setStateArrayItemProperty(providerId, key, !isDefault, setDebtCollectionProviders)
                }
                else {
                    setDebtCollectionProviders(previousProviders => previousProviders.map(provider => {
                        if (provider.id === providerId) {
                            return { ...provider, isDefault }
                        }
                        if (isDefault && provider.isDefault) {
                            return { ...provider, isDefault: false }
                        }
                        return provider
                    }))
                }
            },
            error => {
                setErrorMessage(error.errorMessage)
                arrayUtilities.setStateArrayItemProperty(providerId, key, !isDefault, setDebtCollectionProviders)
            },
            providerId, isDefault, organisationId, token
        )
    }

    const handleDefaultToggleChange = (providerId, isChecked) => {
        if (isChecked && preExistingDefault !== null) {
            setToggleDefaultId(providerId)
            return
        }
        toggleDebtProviderDefaultStatus(providerId, isChecked, setErrorMessage)
    }

    const handleDefaultWarningCancel = () => {
        arrayUtilities.setStateArrayItemProperty(toggleDefaultId, "isDefault", false, setDebtCollectionProviders)
        setToggleDefaultId(null)
    }

    const handleDefaultWarningConfirm = () => {
        toggleDebtProviderDefaultStatus(toggleDefaultId, true, setErrorMessage)
        setToggleDefaultId(null)
    }

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="card mb-3">
                        <div className="card-header">
                            <div className="row align-items-center justify-content-between">
                                <div className="col-auto d-flex align-items-center pr-0">
                                    <h5 className="mb-0">Debt Collection Providers</h5>
                                </div>
                                <div className="col-auto text-right pl-0 filter-buttons-wrapper">
                                    <Link className="btn btn-success btn-sm mr-1 ml-1" to={ `/organisation/${ organisationId }/debt-collection-provider` }><i className="fas fa-plus mr-1"></i>Add</Link>
                                </div>
                            </div>
                        </div>
                        <div className="card-body bg-light border-top p-0">
                            <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer" style={ { tableLayout: 'fixed' } }>
                                <thead className="bg-200 text-900">
                                    <tr>
                                        <th style={ { width: '30%' } }>Name</th>
                                        <th>Method</th>
                                        <th className='text-center' style={{width: '5%'}}>Default</th>
                                        <th style={{width: '5%'}}>&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    { isLoading
                                        ? <tr> <td colSpan={ 4 }><Loader /></td></tr>
                                        : !arrayUtilities.isNullOrEmpty(debtCollectionProviders) && debtCollectionProviders.map(provider =>
                                            <tr key={ provider.id }>
                                                <td className="text-truncate"><Link to={ `/organisation/${ organisationId }/debt-collection-provider/${ provider.id }` } className="d-flex align-items-center"><h6 className="mb-0 text-truncate" title={ provider.name }>{ provider.name }</h6></Link></td>
                                                <td>{ Enum.DebtCollectionType[provider.debtCollectionType] }</td>
                                                <td className="toggle-align-start text-center">
                                                    <ToggleWithLocalisedLoading
                                                        checked={ provider.isDefault }
                                                        id={ `${ provider.id }-make-debt-provider-default` }
                                                        onChange={ isChecked => handleDefaultToggleChange(provider.id, isChecked) }
                                                        loadingStateTracker={ provider }
                                                    />
                                                </td>
                                                <td className='text-right pr-3'>
                                                    <Link to={ {
                                                        pathname: `/organisation/${ organisationId }/debt-collection-provider/${ provider.id }`,
                                                        state: { editMode: true }
                                                    } } className='btn btn-none p-0 m-0 ml-2' type='button'>
                                                        <i className='fas fa-edit'></i>
                                                    </Link>
                                                    <button onClick={ () => setDeleteModal(provider) } className='btn btn-none p-0 m-0 ml-2' type='button'>
                                                        <i className='fas fa-trash-alt'></i>
                                                    </button>
                                                </td>
                                            </tr>)
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {
                deleteModal &&
                <Modal show onHide={ () => setDeleteModal(null) } centered>
                    <Modal.Header>
                        <Modal.Title className="d-flex gap-2 align-items-center text-danger">Delete debt collection provider</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p className="font-weight-semi-bold mt-1 mb-2">Are you sure you want to delete <b>{ deleteModal.name }</b>?</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={ () => setDeleteModal(null) }>Cancel</button>
                        <button type="button" className="btn btn-danger btn-sm ml-2" onClick={ () => {
                            setDeleteModal(null)
                            handleDelete()
                        } }>Delete</button>
                    </Modal.Footer>
                </Modal>
            }
            {
                toggleDefaultId &&
                <Modal show onHide={ handleDefaultWarningCancel } centered>
                    <Modal.Header>
                        <Modal.Title className="d-flex gap-2 align-items-center text-warning">Default status change</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p className="font-weight-semi-bold mt-1 mb-2">
                            Are you sure you want to set <b>{debtCollectionProviders.find(item => item.id === toggleDefaultId).name}</b> as the default debt collection provider?
                        </p>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={ handleDefaultWarningCancel }>Cancel</button>
                        <button type="button" className="btn btn-primary btn-sm ml-2" onClick={ handleDefaultWarningConfirm }>Set as default</button>
                    </Modal.Footer>
                </Modal>
            }
            { !stringHelpers.isNullOrEmpty(errorMessage) && <ErrorModal message={ errorMessage } onHide={ () => setErrorMessage(null) } /> }
        </div>
    )
}